import {Injectable} from "@angular/core";
import { AngularFireDatabase } from'angularfire2/database/database';
import { AngularFireAuth } from'angularfire2/auth/auth';
import { Http, Headers } from "@angular/http";
import { Router } from "@angular/router";
import * as firebase from 'firebase/app';

@Injectable()

export class AutorizacionService{

    username = null;
    email = null;

  
  constructor(private AngularFireAuth: AngularFireAuth, private router:Router){ 
        this.isLogged();
  }
    public facebookLogin(){

        this.AngularFireAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider())
            .then((result)=>{
                this.username = result.user.displayName;
                alert('Usuario Loggeado con Facebook');
                console.log(result);
                this.router.navigate(['lugares']);
                console.log(this.username)
            })
           .catch((error)=>{
                console.log(error)
            })
}

    public login = (email, password) => {
        this.AngularFireAuth.auth.signInWithEmailAndPassword(email, password)
            .then((response)=>{
                this.username = response.email;
                alert('Usuario Registrado con éxito!');
                console.log(response);
                this.router.navigate(['lugares']);
                console.log(this.username);
            })
            .catch((error)=>{
                alert('Un error ha ocurrido');
                console.log(error);
            })
    }


    public registro = (email, password) => {
        this.AngularFireAuth.auth.createUserWithEmailAndPassword(email, password)
            .then((response)=>{
                alert('Usuario Registrado con éxito!');
                console.log(response);
            })
            .catch((error)=>{
                alert('Un error ha ocurrido');
                console.log(error);
            })
    }


    public isLogged(){
        return this.AngularFireAuth.authState;
    }

    public logout(){

        this.AngularFireAuth.auth.signOut();
        alert('Ha salido de su cuenta');
        this.router.navigate(['lugares']);
    }


    public getUser(){
        return this.AngularFireAuth.auth;
    }
};




// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/services/autorizacion.service.ts